import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { noop } from "@client/shared/constants";
import { Grid, FilterComponent } from "@client/shared/components";
import Paper from "@mui/material/Paper";
import style from "./style";

const UserPermissionsView = ({
  isLoading = false,
  loaderConfig = { rows: [] },
  columns = [],
  entries = [],
  totalEntries = 0,
  isFiltering = false,
  filters = [],
  filterConfig = [],
  pageNumber = 1,
  pageSize = 5,
  order = null,
  orderBy = "",
  onFilterReady = noop,
  handleFilterChange = noop,
  handleFilterClose = noop,
  handlePageNumberChange = noop,
  handlePageSizeChange = noop,
  handleSort = noop,
}) => {
  return (
    <>
      <Box>
        <Box sx={style.pageHeadingWrapper}>
          <Typography sx={style.pageHeading} variant="h5">
            User Permissions
          </Typography>
          <Typography sx={style.pageHeadingCaption} variant="caption">
            Changes to individual user permissions will need to be made in Service Web.
          </Typography>
          <Box style={style.pageHeadingMarker}></Box>
        </Box>
      </Box>
      <Box sx={style.actionWrapper}>
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row-reverse'}}>
          <FilterComponent
            isFiltering={isFiltering}
            filterConfig={filterConfig}
            appliedFilters={filters}
            onFilterApply={handleFilterChange}
            onFilterClose={handleFilterClose}
            onReady={onFilterReady}
          />
        </Box>
      </Box>
      <Paper elevation={1}>
        <Grid
          hasLoader
          hasSelection={false}
          columns={columns}
          rows={entries || []}
          totalRows={totalEntries}
          filters={filters}
          isFiltering={isFiltering}
          isLoading={isLoading}
          loaderConfig={loaderConfig}
          onFilterClose={handleFilterClose}
          onPageNumberChange={handlePageNumberChange}
          onPageSizeChange={handlePageSizeChange}
          onSortChange={handleSort}
          pageNumber={pageNumber}
          pageSize={pageSize}
          order={order}
          orderBy={orderBy}
          classes={{
            container: style.tablePaper,
          }}
        />
      </Paper>
    </>
  );
};

export default UserPermissionsView;
